<template>
    <div>
        <div id="inviteCandidateModal" class="modal">
            <div class="modal-contents">
                <span class="close" @click="modalClose()">&times;</span>
                <div class="update-course">
                    <div class="modal-heading">
                        <h1 class="main-heading">Invite New Candidates</h1>
                    </div>
                    <ul class="nav nav-tabs nav-padd-20">
                        <li class="active"><a data-toggle="tab" href="#email_invite">Email Invitation</a></li>
                        <li><a data-toggle="tab" href="#whatsapp_invite">WhatsApp Invitation</a></li>
                        <li><a data-toggle="tab" href="#bulk_invite">Bulk Email Invitation</a></li>
                    </ul>
                    <div class="tab-content">
                        <div id="email_invite" class="tab-pane fade in active">
                            <div class="update-cour invite-main">
                                <div class="row">
                                    <div class="col-md-12">
                                        <form id="invite-individually" @submit.prevent="inviteIndividually($event)">
                                            <div class="row">
                                                <div class="col-md-10 col-md-offset-1 invitation-main">
                                                    <div class="row invitation-inner-main">
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <!--                                                                <label class="ep-input-label">Name</label>-->
                                                                <input type="text"
                                                                       class="form-control dash-input add_invitation_name"
                                                                       placeholder="Name">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <!--                                                                <label class="ep-input-label">Email</label>-->
                                                                <input type="text"
                                                                       class="form-control dash-input add_invitation_email"
                                                                       placeholder="Email">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <!--                                                                <label class="ep-input-label">Phone</label>-->
                                                                <input type="number"
                                                                       class="form-control dash-input add_invitation_phone"
                                                                       placeholder="Phone">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row invitation-inner-main">
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <input type="text"
                                                                       class="form-control dash-input add_invitation_name"
                                                                       placeholder="Name">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <input type="text"
                                                                       class="form-control dash-input add_invitation_email"
                                                                       placeholder="Email">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <input type="number"
                                                                       class="form-control dash-input add_invitation_phone"
                                                                       placeholder="Phone">
                                                            </div>
                                                        </div>
                                                        <div class="remove-elem"><i class="fa fa-times"></i></div>
                                                    </div>
                                                    <div class="row invitation-inner-main">
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <input type="text"
                                                                       class="form-control dash-input add_invitation_name"
                                                                       placeholder="Name">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <input type="text"
                                                                       class="form-control dash-input add_invitation_email"
                                                                       placeholder="Email">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <input type="number"
                                                                       class="form-control dash-input add_invitation_phone"
                                                                       placeholder="Phone">
                                                            </div>
                                                        </div>
                                                        <div class="remove-elem"><i class="fa fa-times"></i></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-10 col-md-offset-1">
                                                <a href="javascript:;" class="add-more-main" @click="addMore()">
                                                    <i class="far fa-plus-square"></i> Add More
                                                </a>
                                            </div>
                                            <div class="col-md-12 text-center">
                                                <div class="form-group">
                                                    <button type="submit" class="ss-button">Invite</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="whatsapp_invite" class="tab-pane fade">
                            <div class="update-cour invite-main">
                                <div class="row">
                                    <div class="col-md-12">
                                        <form id="whatsapp-invite-individually"
                                              @submit.prevent="whatsappInviteIndividually($event)">
                                            <div class="row">
                                                <div class="col-md-10">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <input type="text" class="form-control dash-input"
                                                                       id="whatsapp_name" placeholder="Name"
                                                                       v-model="wName">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <input type="text" class="form-control dash-input"
                                                                       id="whatsapp_phone" placeholder="Phone"
                                                                       v-model="wPhone">
                                                                <div v-html="wPhoneError"
                                                                     class="form-text text-muted"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-2 text-center margin-top-20">
                                                    <div class="form-group">
                                                        <button type="submit" class="ss-button">Invite</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="bulk_invite" class="tab-pane fade">
                            <div class="update-cour invite-main">
                                <div class="row">
                                    <div class="col-md-6 border-right-1px">
                                        <div class="form-group">
                                            <label class="ep-input-label float-left">Enter Multiple Emails</label>
                                            <textarea cols="7" class="form-control dash-input"
                                                      placeholder="Emails example: abc@gmail.com, pqr@gmail.com"
                                                      v-model="iEmails"></textarea>
                                            <div v-html="iEmailsError" class="form-text text-muted"></div>
                                        </div>
                                        <div class="col-md-12 text-center">
                                            <div class="form-group">
                                                <button type="button" class="ss-button margin-top-0"
                                                        @click="submitMultipleEmails()">Invite
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <form id="invite-via-file" @submit.prevent="inviteFile($event)">
                                            <div class="form-group">
                                                <label class="ep-input-label float-left">Upload CSV File Here</label>
                                                <input type="file" class="file-input" id="uploadFile" ref="file"
                                                       v-on:change="handleFileUpload()" accept=".csv"/>
                                                <label class="file-dropable" for="uploadFile">
                                                    <i id="uploadIcon" class="fas fa-cloud-upload-alt"></i>
                                                    <h4 v-html="file_name"></h4>
                                                </label>
                                            </div>
                                            <div v-html="iFileEmailsError" class="form-text text-muted"></div>
                                            <div class="col-md-12 text-center">
                                                <div class="form-group">
                                                    <button type="submit" class="ss-button margin-top-0">Invite</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h2 class="text-center">or</h2>
                    <div class="col-md-10 col-md-offset-1 text-center">
                        <p class="margin-top-20 mb-0">Share this link with your Students for ecampus Signup.</p>
                        <div class="pd-sec-box tooltip-main" v-on:click="copyToClipboard($event)">
                            <input type="text" class="form-control dash-input" :value="'https://www.myecampus.in/signup?ref=' + this.$store.getters.getRefId" readonly>
                            <i class="far fa-copy copy-to-clipboard2" title="Tap to Copy"></i>
                            <span class="tooltiptext tooltip-bottom">Click to Copy</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import toastr from '../../public/js/toastr.js';
    import axios from 'axios';
    import {hideLoader, requestHeaders, showLoader} from "../_helpers/apiHelper";

    export default {
        data() {
            return {
                iEmail: '',
                iPhone: '',
                wPhone: '',
                iName: '',
                wName: '',
                iEmails: '',
                iEmailError: '',
                iPhoneError: '',
                wPhoneError: '',
                iEmailsError: '',
                file: '',
                file_name: 'Upload File Here',
                fileinput: '',
                iData: '',
                iFileEmailsError: '',
                inviteTemplate: `<div class="row invitation-inner-main" style="position: relative;"><div class="col-md-4"><div class="form-group"><input type="text" class="form-control dash-input add_invitation_name" placeholder="Name"></div></div><div class="col-md-4"><div class="form-group"><input type="text" class="form-control dash-input add_invitation_email" placeholder="Email"></div></div><div class="col-md-4"><div class="form-group"><input type="text" class="form-control dash-input add_invitation_phone" placeholder="Phone"></div></div><div class="remove-elem" style="position: absolute;right: -10px;cursor: pointer;top: 25%;color: #00a0e3;"><i class="fa fa-times"></i> </div></div>`,
            }
        },
        mounted() {
            this.initializeValidation();
        },
        methods: {
            modalClose() {
                $('#inviteCandidateModal').modal('hide');
            },
            handleFileUpload() {
                var t = this;
                t.file_name = '';
                t.iFileEmailsError = '';
                t.file = this.$refs.file.files[0];
                t.file_name = t.file['name'];
                var icon_elem = document.getElementById('uploadIcon');
                if (t.file_name != "") {
                    icon_elem.className = 'fas fa-file-alt';
                } else {
                    icon_elem.className = 'fas fa-cloud-upload-alt';
                }

                const reader = new FileReader();
                reader.readAsText(t.file);
                reader.onload = e => fileMain(e.target.result);

                function fileMain(e) {
                    t.iData = e;
                }
            },
            inviteIndividually() {
                var t = this;
                var validateErrors = $('.formHasError');
                if (validateErrors.length) {
                    return false;
                }
                var elems = document.querySelectorAll('.invitation-inner-main');
                if (elems[0].querySelector('.add_invitation_email').value == "") {
                    elems[0].childNodes[1].childNodes[0].insertAdjacentHTML("beforeend", '<p class="formHasError" style="color: #e40000;">Enter Valid Email</p>')
                    return false;
                }
                for (var i = 0; i < elems.length; i++) {
                    var name = elems[i].querySelector('.add_invitation_name').value;
                    var email = elems[i].querySelector('.add_invitation_email').value;
                    var phone = elems[i].querySelector('.add_invitation_phone').value;
                    if (name != "" || phone != "") {
                        if (email == "") {
                            elems[i].childNodes[1].childNodes[0].insertAdjacentHTML("beforeend", '<p class="formHasError" style="color: #e40000;">Enter Valid Email</p>')
                            return false;
                        }
                    }
                }
                var result = [];
                for (var j = 0; j < elems.length; j++) {
                    var r = {};
                    var i_name = elems[j].querySelector('.add_invitation_name').value;
                    var i_email = elems[j].querySelector('.add_invitation_email').value;
                    var i_phone = elems[j].querySelector('.add_invitation_phone').value;
                    if (i_email != "") {
                        r['name'] = i_name;
                        r['email'] = i_email;
                        r['phone'] = i_phone;
                        result.push(r);
                    }
                }
                showLoader();
                var url = t.$store.getters.getDomain;

                axios.post(`${url}api/v2/college-index/candidate-invitation`, {
                    data: result,
                }, {headers: requestHeaders()})
                    .then(res => {
                        hideLoader();
                        if (res['data']['response']['status'] == 200) {
                            toastr.success('Invitation Send', 'Success');
                            for (var i = 0; i < elems.length; i++) {
                                elems[i].querySelector('.add_invitation_name').value = "";
                                elems[i].querySelector('.add_invitation_email').value = "";
                                elems[i].querySelector('.add_invitation_phone').value = "";
                            }
                        } else {
                            toastr.error('Some error occurred. Try again later', 'Oops!!');
                        }
                    })
            },
            whatsappInviteIndividually() {
                var t = this;
                t.wPhoneError = '';
                if (!this.validatePhone(t.wPhone)) {
                    t.wPhoneError = 'Enter correct number';
                    return false;
                }
                showLoader();
                var url = t.$store.getters.getDomain;

                axios.post(`${url}api/v2/college-index/whatsapp-invitation`, {
                    phone: t.wPhone,
                    name: t.wName
                }, {headers: requestHeaders()})
                    .then(res => {
                        hideLoader();
                        if (res['data']['response']['status'] == 200) {
                            var url = 'https://wa.me/91' + t.wPhone + '?text=' + res['data']['response']['link'];
                            window.open(url, '_blank');
                            toastr.success('Invitation Send', 'Success');
                            t.wPhone = '';
                            t.wName = '';
                        } else {
                            toastr.error('Some error occurred. Try again later', 'Oops!!');
                        }
                    })
            },
            submitMultipleEmails() {
                var t = this;
                var mail_er = [];
                var imails = [];
                t.iEmailsError = '';
                if (t.iEmails == "") {
                    t.iEmailsError = "Emails cannot be blank.";
                    return false;
                }
                var mails = t.iEmails;
                mails = mails.trim().split(',');

                for (var i = 0; i < mails.length; i++) {
                    if (this.validateEmail(mails[i].trim())) {
                        imails.push(mails[i].trim());
                    } else {
                        mail_er.push(mails[i].trim());
                    }
                }

                if (imails.length == 0) {
                    t.iEmailsError = 'please enter correct emails';
                    return false;
                }


                showLoader();
                var url = t.$store.getters.getDomain;

                axios.post(`${url}api/v2/college-index/candidates-invitation`, {
                    emails: imails,
                }, {headers: requestHeaders()})
                    .then(res => {
                        hideLoader();
                        if (res.status == 200) {
                            // var course = res['data']['response']['courses'];
                            toastr.success('Invitation Send', 'Success');
                            t.iEmails = '';
                        } else {
                            toastr.error('Some error occurred. Try again later', 'Oops!!');
                        }
                    })
            },
            inviteFile() {
                var t = this;
                var mail_er = [];
                var imails = [];
                var result = [];
                var iemails = {};
                t.iFileEmailsError = '';


                if (t.iData.length == '') {
                    t.iFileEmailsError = 'Please upload file';
                    return false;
                }

                var data = t.iData.split(/\r\n|\n/);

                var first_row = data[0].trim().split(',');
                for (var i = 1; i < data.length; i++) {
                    iemails = {};
                    for (var j = 0; j < first_row.length; j++) {
                        var d = data[i].split(',');
                        if (first_row[j].toLowerCase() == 'name') {
                            iemails['name'] = d[j]
                        } else if (first_row[j].toLowerCase() == 'email') {
                            iemails['email'] = d[j]
                        } else if (first_row[j].toLowerCase() == 'phone') {
                            iemails['phone'] = d[j]
                        }
                    }
                    result.push(iemails);
                }

                showLoader();
                var url = t.$store.getters.getDomain;

                axios.post(`${url}api/v2/college-index/candidates-file-invitation`, {
                    emails: result,
                }, {headers: requestHeaders()})
                    .then(res => {
                        hideLoader();
                        if (res['data']['response']['status'] == 200) {
                            toastr.success('Invitation Send', 'Success');
                            t.iEmails = '';
                        } else {
                            toastr.error('Some error occurred. Try again later', 'Oops!!');
                        }
                    })
            },
            validateEmail(email) {
                var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
                if (reg.test(email) == false) {
                    return false;
                }
                return true;
            },
            validatePhone(phone) {
                var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                if (phoneno.test(phone) == false) {
                    return false;
                }
                return true;
            },
            addMore() {
                var elem_main = document.getElementsByClassName('invitation-main');
                elem_main[0].insertAdjacentHTML("beforeend", this.inviteTemplate);
                this.initializeValidation();
            },
            initializeValidation: function () {
                var t = this;
                $(document).on('blur', '.add_invitation_phone', function (e) {
                    e.preventDefault();
                    var phone_val = $(this).val();
                    var has_error = $(this).parent().children('p');
                    if (t.validatePhone(phone_val)) {
                        if (has_error.length) {
                            has_error.remove();
                        }
                    } else {
                        if (!has_error.length) {
                            $(this).parent().append('<p class="formHasError" style="color: #e40000;">Enter Valid Phone</p>')
                        }
                    }
                });
                $(document).on('blur', '.add_invitation_email', function (e) {
                    e.preventDefault();
                    var email_val = $(this).val();
                    var has_error = $(this).parent().children('p');
                    if (t.validateEmail(email_val)) {
                        if (has_error.length) {
                            has_error.remove();
                        }
                    } else {
                        if (!has_error.length) {
                            $(this).parent().append('<p class="formHasError" style="color: #e40000;">Enter Valid Email</p>')
                        }
                    }
                });
                $(document).on('click', '.remove-elem', function (e) {
                    e.preventDefault();
                    $(this).parent().remove();
                });
                $('.add_invitation_email, .add_invitation_phone, .add_invitation_name').on('keypress', function (e) {
                    if (e.which == 13) {
                        e.preventDefault();
                        return false
                    }
                });
            },
            copyToClipboard(event) {
                var element = event.currentTarget;
                var link = element.childNodes[0].value;
                var temp = $("<input>");
                $("body").append(temp);
                temp.val(link).select();
                document.execCommand("copy");
                temp.remove();
                toastr.success('Copied to Clipboard', 'Copied');
            },
        }
    }
</script>

<style scoped>
    .copy-to-clipboard2{
        position: absolute;
        right: 8px;
        top: 23px;
        background-color: #eee;
    }
    .modal-contents {
        overflow: hidden !important;
        position: relative;
        background-color: #fff;
        overflow-y: scroll !important;
    }

    .modal-heading {
        text-align: center;
        padding: 10px;
    }

    .invite-main {
        max-width: 700px;
        margin: 0 auto;
    }

    .ss-button {
        background: #00a0e3;
        padding: 10px 15px;
        color: #fff;
        border-radius: 10px 0px 10px 0;
        font-size: 13px;
        border: none;
        margin-top: 15px;
    }

    .ss-button:hover {
        text-decoration: none;
        border-radius: 0px;
        transition: .5s all;
    }

    #invite-individually label, .float-left {
        float: left;
    }

    textarea.dash-input {
        height: 150px;
    }

    .margin-top-0 {
        margin-top: 0px;
    }

    .border-right-1px {
        border-right: 1px solid #eee;
    }

    .file-input {
        height: 0px;
        visibility: hidden;
    }

    .file-dropable {
        width: 100%;
        height: 150px;
        border: 1px dashed #eee;
        cursor: pointer;
        padding: 40px;
        text-align: center;
    }

    .file-dropable i {
        font-size: 34px;
    }

    .nav-tabs > li {
        text-align: center;
        margin-bottom: -1px;
        float: none;
        display: inline-block;
    }

    .nav-tabs li.active a {
        border: 0px !important;
    }

    .nav-tabs > li > a {
        border-radius: 0;
        font-family: 'Open Sans', sans-serif;
        font-size: 12px;
        padding: 12px 20px;
        margin-right: 0;
        background-color: #fff;
        color: #222;
    }

    /*----tabs----*/
    .nav-tabs > li.active a, .nav-tabs > li.active a:hover, .nav-tabs > li.active a:focus {
        color: #fff;
        background-color: #00a0e3;
        box-shadow: 2px 4px 17px rgba(221, 216, 216, 0.8);
        transition: .2s all;
    }

    .nav-tabs > li > a:hover {
        box-shadow: 2px 4px 17px rgba(221, 216, 216, 0.8);
        color: #00a0e3;
    }

    .nav-tabs, .nav-tabs > li > a, .nav-tabs > li > a:hover {
        border: none;
    }

    ul.nav.nav-tabs.nav-padd-20 {
        text-align: center;
        margin-bottom: 20px;
    }

    /*----tabs end----*/
    .remove-elem {
        position: absolute;
        right: -10px;
        cursor: pointer;
        top: 25%;
        color: #00a0e3;
    }

    .invitation-inner-main {
        position: relative;
    }
    .pd-sec-box.tooltip-main{
        max-width: 450px;
        margin: auto;
        cursor: copy;
    }
    .pd-sec-box.tooltip-main *{
        cursor: copy;
    }
</style>